import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

interface AnamnesisData {
  current_illness_history?: string;
  personal_history?: string;
  family_history?: string;
  allergies?: string;
  current_medications?: string;
  habits?: string;
}

interface AnamnesisSectionProps {
  data: AnamnesisData;
  onChange: (data: AnamnesisData) => void;
}

export function AnamnesisSection({ data, onChange }: AnamnesisSectionProps) {
  const updateField = (field: keyof AnamnesisData, value: string) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Anamnese</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="current_illness_history">História da Doença Atual (HDA)</Label>
          <Textarea
            id="current_illness_history"
            placeholder="Descreva a história da doença atual, início dos sintomas, evolução..."
            rows={4}
            value={data.current_illness_history || ""}
            onChange={(e) => updateField("current_illness_history", e.target.value)}
          />
        </div>

        <Separator />

        <div className="space-y-2">
          <Label htmlFor="personal_history">Antecedentes Pessoais</Label>
          <Textarea
            id="personal_history"
            placeholder="Doenças prévias, cirurgias, internações..."
            rows={3}
            value={data.personal_history || ""}
            onChange={(e) => updateField("personal_history", e.target.value)}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="family_history">Antecedentes Familiares</Label>
          <Textarea
            id="family_history"
            placeholder="Histórico familiar de doenças..."
            rows={2}
            value={data.family_history || ""}
            onChange={(e) => updateField("family_history", e.target.value)}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="allergies">Alergias</Label>
            <Textarea
              id="allergies"
              placeholder="Medicamentos, alimentos, outras alergias..."
              rows={2}
              value={data.allergies || ""}
              onChange={(e) => updateField("allergies", e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="current_medications">Medicamentos em Uso</Label>
            <Textarea
              id="current_medications"
              placeholder="Liste os medicamentos que o paciente utiliza..."
              rows={2}
              value={data.current_medications || ""}
              onChange={(e) => updateField("current_medications", e.target.value)}
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="habits">Hábitos</Label>
          <Textarea
            id="habits"
            placeholder="Tabagismo, etilismo, atividade física, alimentação..."
            rows={2}
            value={data.habits || ""}
            onChange={(e) => updateField("habits", e.target.value)}
          />
        </div>
      </CardContent>
    </Card>
  );
}
